import { render, staticRenderFns } from "./sharePressRele2.vue?vue&type=template&id=5adf1edb&scoped=true&"
import script from "./sharePressRele2.vue?vue&type=script&lang=js&"
export * from "./sharePressRele2.vue?vue&type=script&lang=js&"
import style0 from "./sharePressRele2.vue?vue&type=style&index=0&id=5adf1edb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf1edb",
  null
  
)

export default component.exports